// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { DropdownTokens } from './type';

const dropdownTokens: DropdownTokens = {
  dropdownCaretMarginLeft: 'Margin-4',
  dropdownListBorderRadius: 'Radius-4',
  dropdownListPaddingX: 'Padding-4',
  dropdownListPaddingY: 'Padding-4',
  dropdownListFontSize: '14/regular',
  dropdownListSmallBorderRadius: 'Radius-4',
  dropdownListSmallPaddingX: 'Padding-4',
  dropdownListSmallPaddingY: 'Padding-4',
  dropdownListSmallFontSize: '12/regular',
  dropdownListLargeBorderRadius: 'Radius-4',
  dropdownListLargePaddingX: 'Padding-4',
  dropdownListLargePaddingY: 'Padding-4',
  dropdownListLargeFontSize: '16/regular',
  dropdownListBackgroundColor: 'Neutral-fill-1',
  dropdownListBorderColor: 'Neutral-border-1',
  dropdownListFontColor: 'Neutral-text-5',
  dropdownListBoxShadow: 'Shadow-2',
  dropdownListBorderWidth: 'Border-1',
  dropdownOptionPaddingX: 'Padding-8',
  dropdownOptionPaddingY: 'Padding-5',
  dropdownOptionSmallPaddingX: 'Padding-8',
  dropdownOptionSmallPaddingY: 'Padding-2',
  dropdownOptionLargePaddingX: 'Padding-12',
  dropdownOptionLargePaddingY: 'Padding-8',
  dropdownOptionBackgroundColor: 'Neutral-fill-1',
  dropdownOptionFontColor: 'Neutral-text-5',
  dropdownOptionHoverBackgroundColor: 'Neutral-fill-2',
  dropdownOptionHoverFontColor: 'Neutral-text-5',
  dropdownOptionActiveBackgroundColor: 'Neutral-fill-3',
  dropdownOptionActiveFontColor: 'Neutral-text-5',
  dropdownOptionSelectBackgroundColor: 'Brand-1',
  dropdownOptionSelectFontColor: 'Brand-6',
  dropdownOptionDisabledBackgroundColor: 'Neutral-fill-1',
  dropdownOptionDisabledFontColor: 'Neutral-text-2',
  dropdownColumnPaddingX: 'Padding-4',
  dropdownColumnPaddingY: 'Padding-4',
  dropdownOptionGroupPaddingX: 'Padding-8',
  dropdownOptionGroupPaddingTop: 'Padding-10',
  dropdownOptionGroupPaddingBottom: 'Padding-2',
  dropdownOptionGroupFontSize: '12/regular',
  dropdownOptionGroupFontColor: 'Neutral-text-3',
  dropdownOptionGroupSmallX: 'Padding-8',
  dropdownOptionGroupSmallTop: 'Padding-4',
  dropdownOptionGroupLargeX: 'Padding-12',
  dropdownOptionGroupLargeTop: 'Padding-14',
  dropdownOptionGroupLargeBottom: 'Padding-4',
  dropdownOptionDividerBackgroundColor: 'Neutral-border-1',
  dropdownOptionDividerPaddingX: 'Padding-8',
  dropdownOptionDividerPaddingY: 'Padding-2',
  dropdownOptionDividerHeight: 'Border-1',
};

export default dropdownTokens;
